import {ready} from '~/core'
import createElement from '~/utils/createElement';
ready('blockList', '.blockList', blockList => {
    const blockListCopy = blockList.querySelectorAll('.blockList-blurb')
    if (blockListCopy.length) {
        blockListCopy.forEach(blockList => {
            const limit = 50;
            let contentCount = blockList.textContent.trim().split(' ').length;
            if (contentCount > limit) {
                const toggle = createElement('div', {
                    class: 'blockList-toggle'
                })
                const toggleInner = createElement('span', {
                    class: 'blockList-toggleInner'
                }, 'Show More')
                const showingWrapper = createElement('span', {
                    class: 'is-truncated'
                })
                const hiddenWrapper = createElement('span', {
                    class: 'is-hidden'
                })

                // Get the inner content of the element
                let contentOrig = blockList.textContent.trim();

                // Convert the content into an array of words
                // Remove any words above the limit
                let contentTrimmed = contentOrig.split(' ').slice(0, limit);
                let contentLeft = contentOrig.split(' ').slice(limit);


                // Convert the array of words back into a string
                // If there's content to add after it, add it
                let contentNew = contentTrimmed.join(' ');
                let contentHidden = ' ' + contentLeft.join(' ');
                // Inject the content back into the DOM
                blockList.textContent = '';
                blockList.prepend(showingWrapper)
                showingWrapper.textContent = contentNew;
                blockList.append(hiddenWrapper)
                hiddenWrapper.textContent = contentHidden;
                blockList.append(toggle)
                toggle.append(toggleInner)

                //new
                toggleInner.addEventListener('click', function (event) {
                    if (hiddenWrapper.classList.contains('is-hidden')) {
                        hiddenWrapper.classList.remove('is-hidden')
                        hiddenWrapper.classList.add('is-showing')
                        toggleInner.textContent = 'Show Less';
                        blockList.classList.add('is-expanded')
                    } else if (hiddenWrapper.classList.contains('is-showing')) {
                        hiddenWrapper.classList.remove('is-showing')
                        hiddenWrapper.classList.add('is-hidden')
                        toggleInner.textContent = 'Show More';
                        blockList.classList.remove('is-expanded')
                    }
                })
            }
        });
    }
});